<div class="container my-5">
  <header class="text-center mb-4">
    <h1>Change Log</h1>
    <p class="text-muted">Keep track of all the updates and improvements</p>
  </header>

  <div id="changeLogAccordion">
    <!-- Version 1.3.0 -->
    <div class="card">
      <div class="card-header" id="heading0">
        <h2 class="mb-0">
          <button class="btn btn-link d-flex justify-content-between align-items-center" type="button"
            data-toggle="collapse" data-target="#collapse0" aria-expanded="true" aria-controls="collapse0">
            Version 1.3.0 - July 20, 2025
          </button>
        </h2>
      </div>
      <div id="collapse0" class="collapse show" aria-labelledby="heading0" data-parent="#changeLogAccordion">
        <div class="card-body">
          <ul>
            <li>New feature: Introduced Diamond membership tier with exclusive benefits</li>
            <li>New feature: Added subscription plans with monthly options</li>
            <li>Improvement: Enhanced member benefits and rewards system</li>
            <li>Improvement: Updated pricing structure for all subscription tiers</li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Version 1.2.0 -->
    <div class="card">
      <div class="card-header" id="heading1">
        <h2 class="mb-0">
          <button class="btn btn-link d-flex justify-content-between align-items-center collapsed" type="button"
            data-toggle="collapse" data-target="#collapse1" aria-expanded="false" aria-controls="collapse1">
            Version 1.2.0 - December 20, 2024
          </button>
        </h2>
      </div>
      <div id="collapse1" class="collapse" aria-labelledby="heading1" data-parent="#changeLogAccordion">
        <div class="card-body">
          <ul>
            <li>New feature: Added user profile page with editable settings.</li>
            <li>Improvement: Enhanced loading times by optimizing images and scripts.</li>
            <li>Bug Fix: Resolved an issue causing crashes on older browsers.</li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Version 1.1.0 -->
    <div class="card">
      <div class="card-header" id="heading2">
        <h2 class="mb-0">
          <button class="btn btn-link d-flex justify-content-between align-items-center collapsed" type="button"
            data-toggle="collapse" data-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
            Version 1.1.0 - November 10, 2024
          </button>
        </h2>
      </div>
      <div id="collapse2" class="collapse" aria-labelledby="heading2" data-parent="#changeLogAccordion">
        <div class="card-body">
          <ul>
            <li>New feature: Introduced dark mode for better usability at night.</li>
            <li>Improvement: Updated navigation bar design for improved accessibility.</li>
            <li>Bug Fix: Fixed alignment issues on smaller screens.</li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Version 1.0.0 -->
    <div class="card">
      <div class="card-header" id="heading3">
        <h2 class="mb-0">
          <button class="btn btn-link d-flex justify-content-between align-items-center collapsed" type="button"
            data-toggle="collapse" data-target="#collapse3" aria-expanded="false" aria-controls="collapse3">
            Version 1.0.0 - October 1, 2024
          </button>
        </h2>
      </div>
      <div id="collapse3" class="collapse" aria-labelledby="heading3" data-parent="#changeLogAccordion">
        <div class="card-body">
          <ul>
            <li>Initial release with core functionality.</li>
            <li>Implemented responsive design for mobile and desktop users.</li>
            <li>Added support for multiple languages.</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>